import React, { useEffect, useState } from 'react';
// Constants
import {
  CompanyName,
  KeywordsPages,
  LocationCountry,
} from '../../utils/Constants';
// Data
import {
  ratesTributesPageAdditionalMeta,
  ratesTributesPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GeneralHeader from '../../components/header/GeneralHeader';
import RatesPageMainContainer from '../../components/rates/RatesPageMainContainer';

function RatesPage() {
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('scroll-section-rates');
      if (!section) return;

      const sectionBottom = section.getBoundingClientRect().bottom;
      setHideNavbar(sectionBottom <= 130); // Hide navbar 50px before section disappears
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Rates & Tributes'
        desc={`Experience the power of ${CompanyName} in ${LocationCountry}. Book a real-time BDSM session in a fully equipped dungeon.`}
        keywords={`real-time sessions, BDSM, domination, submission, ${CompanyName}, ${LocationCountry}, dungeon, booking, ${KeywordsPages}`}
        additionalMeta={ratesTributesPageAdditionalMeta}
        structuredData={ratesTributesPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen font-main bg-colour1 dark:bg-colour2 text-colour2 dark:text-colour1 overflow-hidden'>
        {/* Nav + header section */}
        <div
          id='scroll-section-rates'
          className='grid bg-colour4 dark:bg-colour4 full_shadow_black_invert min-h-[45vh] max-h-[45vh]'
        >
          {/* Navigation */}
          <Navbar isHidden={hideNavbar} />
          {/* Header */}
          <GeneralHeader
            page={`Rates & Tributes`}
            title={`Spoil me and treat me like a Goddess!`}
          />
        </div>

        {/* Main page content */}
        <RatesPageMainContainer />
      </div>
    </>
  );
}

export default RatesPage;
